export default __webpack_public_path__ + "static/media/uploader-insuletOmnipod-problem-3.bfae151d.png";